import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const LeadDetailLayout = () => {
    const navList = useNav();
      let {LeadDetailBottomHeader, LeadsTopHeader} = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={LeadDetailBottomHeader} topTabs={LeadsTopHeader} />
            <Outlet />
        </div>
    )
}

export default LeadDetailLayout;